// Load components
import { Burger } from "./components/burger";
import { FloatLabel } from "./components/floating-label";
import { gridDebug } from "./components/grid-debug";
import { Accordion } from "./components/accordion.js";

const mediaQuery = window.matchMedia("(max-width: 768px)");

// Issue when submiting AJAX form -> Convert to vanilla if you DARE !!
jQuery(document).bind("gform_post_render", function () {
	FloatLabel.init();
});

document.addEventListener("DOMContentLoaded", (e) => {
	// Load grid debug on dev environement
	if (themeVars.is_dev) gridDebug.init();

	// Load components
	Burger.init();
	FloatLabel.init();
	Accordion.init();

	// Sitcky header
	const header = document.querySelector(".header");
	const searchFormH = header.querySelector(".searchform__header");
	const headerTop = header.getBoundingClientRect().top;

	document.body.style.setProperty("--_header-h", `${header.offsetHeight}px`);
	document.body.style.setProperty("--_searchform-h", `${searchFormH.offsetHeight}px`);

	window.addEventListener("scroll", function () {
		header.classList.toggle("is-sticky", window.scrollY > headerTop + header.offsetHeight);
	});

	let trigger_search = document.getElementById("trigger-search");
	if (trigger_search) {
		trigger_search.addEventListener("click", (e) => {
			e.preventDefault();
			e.currentTarget.classList.toggle("is-active");
			header.classList.toggle("is-search-open");
		});

		// Close search on ESC
		document.addEventListener("keydown", (e) => {
			if (header.classList.contains("is-search-open") && e.key === "Escape") {
				header.classList.remove("is-search-open");
				trigger_search.classList.remove("is-active");
			}
		});

		// Close search on click outside
		document.addEventListener("click", (e) => {
			if (header.classList.contains("is-search-open") && !header.contains(e.target)) {
				header.classList.remove("is-search-open");
				trigger_search.classList.remove("is-active");
			}
		});

		// Focus input when opened
		const searchInput = header.querySelector(".searchform__input");
		if (searchInput) {
			trigger_search.addEventListener("click", () => {
				setTimeout(() => {
					searchInput.focus();
				}, 100);
			});
		}
	}

	if (mediaQuery.matches) {
		// Sticky nav
		const sticky_nav = document.querySelector(".sticky-nav");
		const sticky_nav_trigger = sticky_nav?.querySelector(".sticky-nav__trigger");
		const toggle_sticky_nav = document.querySelector(".life-path__toggle-sm");

		if (sticky_nav) {
			[sticky_nav_trigger, toggle_sticky_nav].forEach((button) => {
				if (button) {
					button.addEventListener("click", () => {
						sticky_nav.classList.toggle("is-open");
					});
				}
			});
		}

		// Toggle Footer's nav on mobile
		const footer_nav_rows = document.querySelectorAll(".footer-nav__row");
		if (footer_nav_rows.length > 0) {
			footer_nav_rows.forEach((row) => {
				let trigger = row.querySelector("[data-footer-subnav]");
				if (!trigger) return;

				trigger.addEventListener("click", (e) => {
					e.preventDefault();

					let isOpen = row.classList.contains("is-open"); // Vérifie si déjà ouvert

					// Ferme tous les autres
					document.querySelectorAll(".footer-nav__row").forEach((nav) => nav.classList.remove("is-open"));

					// Si l'élément cliqué n'était pas ouvert, on l'ouvre
					if (!isOpen) {
						row.classList.add("is-open");
					}
				});
			});
		}
	}
});
